import styled, { css } from 'styled-components';

import { toVw, toVwMobile, toVwTablet } from '../../../utils/styles';
import mq from '@/utils/media-queries';

export const COL_SIZES = {
  1: 323,
  2: 467,
  3: 575,
  4: 791,
};

// export const COL_SIZES = {
//   1: 252,
//   2: 396,
//   3: 504,
//   4: 720,
// };

const COL_GAP = 36;
const COL_GAP_MD = 26;

const Col = styled.div`
  width: ${props => toVw(COL_SIZES[props.size])};
  margin-right: ${toVw(COL_GAP)};

  &:last-child {
    margin-right: 0;
  }

  ${mq.tablet(css`
    margin-right: ${toVwTablet(COL_GAP_MD)};

    &:first-child {
      width: ${toVwTablet(315)};
    }

    &:nth-child(2) {
      width: ${toVwTablet(631)};
      margin-right: 0;
    }

    &:nth-child(3) {
      margin-top: ${toVwTablet(51)};
      flex-basis: 100%;
    }
  `)};

  ${mq.mobile(css`
    width: 100%;
    margin-right: 0;
    margin-bottom: ${toVwMobile(48)};

    &:first-child,
    &:nth-child(2),
    &:nth-child(3) {
      width: 100%;
    }

    &:nth-child(3) {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  `)};
`;

export default Col;



// WEBPACK FOOTER //
// ./src/components/ContentRows/components/Col.js